import { AllocationColumnTypes } from "../../../utils/types/workbook.type";

export enum ColWidth {spacer=20,text=180, smallText=55, currency=130, percent=40}
export enum InvestorCommitmentRowType {Investor, TypeTotal, PartnerTotal}
export enum ITDType {pitd, ytd, itd}

export type Row = number;
export type Column = string;
export type CellPosition = {col: Column, row: Row};
export type StartEndRows = {startRow: Row, endRow: Row};
export type StartEndCols = {startCol: Column, endCol: Column};

export type InvestorTypeRows = Map<string, StartEndRows>;

export type InvestorCommitmentRow = {
    investorId: string,
    investorType: string,
    investorName: string,
    row: Row, 
    rowType: InvestorCommitmentRowType,
    isNew: boolean,
    totalTransactionAmount: number,
    commitmentDatedColumnAmounts: number[]
};

export type CommitmentDatedColumn = {
    label: string,
    commitmentDate: Date,
    col: Column
}

export type AllocationColumn = {
    id?: string;
    code: string,
    index: number,
    colType: AllocationColumnTypes,
    label: string,
    col: Column
};

export type TransactionColumnDetail = {
    id?: string,
    transTypeId?: string,
    label: string,
    col: Column,
    isUserCol: boolean,
    allocationCol?: AllocationColumn,
    index?: number,
    locked?: boolean,
    transSubmitError?: boolean,
    metricSign: number,
    useArkTransactionValues: boolean
};

export type TransactionColumn = {
    startEndCols: StartEndCols,
    columns: TransactionColumnDetail[]
};

export type SpreadsheetTemplate = {
    reportName: CellPosition,
    quarterHeaderRow: Row,
    mainColHeaderRow: Row,
    investorTypeCol: Column,
    investorNameCol: Column,
    closeCommitmentCol: Column,
    investorCommitmentRows: {
        allCommitmentRows: InvestorCommitmentRow[],
        typeStartEndRows: InvestorTypeRows,
        rowsRemoved: Row[]
    },
    closeCommitmentDatedCols: {
        startEndCols: StartEndCols,
        columns: CommitmentDatedColumn[],
    },
    allocationsCols: { 
        startEndCols: StartEndCols,
        columns: AllocationColumn[]
    },
    pitdCols: TransactionColumn,
    transactionCols: Map<number, TransactionColumn>
    ytdCols: TransactionColumn,
    itdCols: TransactionColumn,
    lastRow: Row,
    lastCol: Column
};
